export class SIQProgressButtonTheme {
  backgroundColor = "null";
  tintcolor = "null";
}
//# sourceMappingURL=SIQProgressButtonTheme.js.map